import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { handlers } from "../../../components/appointmentsWithDocuements/AppointmentsWithDocuments";
import { petDocumentsParams } from "../../../components/appointmentsWithDocuements/AppointmentsWithDocumentsFilter";
import { usePostFilter } from "../../../hooks/Fetching";

export default function useFetchPetDocuments() {
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const size = parseInt(searchParams.get(handlers?.rowsPersPage) ?? "10", 10);
  const pageNumber = parseInt(searchParams.get(handlers?.page) ?? "0", 10);

  var from = searchParams.get(petDocumentsParams.startDate) ?? "";

  var to = searchParams.get(petDocumentsParams.endDate) ?? "";

  if (String(from) === "Invalid Date") {
    from = "";
  }
  if (String(to) === "Invalid Date") {
    to = "";
  }

  let q = searchParams.get(petDocumentsParams?.search) || "";
  q = q === "null" || q?.length < 2 ? null : q;

  const documentCategoryId =
    searchParams.get(petDocumentsParams?.category) || null;
  const fileType = searchParams.get(petDocumentsParams?.fileExtension) || null;
  const sort = searchParams.get(handlers?.ord) || null;

  const filterDto = {
    pageNumber,
    size,
    from,
    to,
    title: q,
    documentCategoryId: documentCategoryId ? Number(documentCategoryId) : null,
    fileType,
    sort,
    currentLang,
  };

  const apiPath = `/pets/pet/files/${id}`;

  const { data, isLoading, error } = usePostFilter(apiPath, filterDto, [
    "petDocuments" + id,
    filterDto.pageNumber,
    filterDto.size,
    filterDto.from,
    filterDto.to,
    filterDto.title,
    filterDto.documentCategoryId,
    filterDto.fileType,
    filterDto.sort,
    filterDto.currentLang,
  ]);

  const fetchData = {
    count: data?.totalCount || [],
    data: data?.data || [],
  };
  return { fetchData, error, isLoading };
}
